import React from 'react';
import CustomButton from "../../../components/UI/customButton/customButton";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

const FailedPage = () => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  return (
    <div className={"my-container"}>
      <div className={" relative bg-white rounded-lg  flex flex-col items-center gap-5 md:gap-9 w-full !mt-20 py-5 md:py-10 px-4 md:px-[13%] mb-8"}>
        <span className={"text-lg md:text-2xl text-red font-medium"}>{t("failPayment")}</span>
        <span className={"md:w-1/2 2xl:w-full text-sm md:text-base text-center leading-8 text-gray-700 font-light md:font-medium"}>{t("successfulPaymentDes")}</span>
        <div className={"m-w-[330px]"}>
          <CustomButton onClick={() => navigate("/")} title={ "understand"}/>
        </div>
      </div>
    </div>
  );
};

export default FailedPage;
